
export enum EventCategory {
  Account = 'account',
  Checkout = 'checkout',
  Cart = 'cart',
  Download = 'download',
  Impression = 'impression',
  Licensing = 'licensing',
  Search = 'search',
  SetFilter = 'set-filter',
}

export enum FilterEvent {
  Budget = 'budget',
}

export enum AccountEvent {
  NewAccount = 'new-account-registration',
}

export enum CartEvent {
  AddToCart = 'add-to-cart',
  RemoveFromCart = 'remove-from-cart',
}

export enum CheckoutEvent {
  Checkout = 'checkout',
  PlaceOrder = 'place-order',
}

export enum LicensingEvent {
  SetLicense = 'set-license',
}

export enum ProductEvent {
  Details = 'track-details',
  Download = 'download-track',
  Impression = 'track-impression',
}

export enum SearchEvent {
  Search = 'search',
  SimilaritySearch = 'similarity-search',
}

export interface IEventMap {
  category: EventCategory;
  event: AccountEvent | CartEvent | CheckoutEvent | LicensingEvent | ProductEvent | SearchEvent | FilterEvent;
  action: string;
  label?: string;
  [key: string]: any;
}

export type EventDefinition<Action> =
  (action: Action, prevState: IStoreState, nextState: IStoreState) =>
    IEventMap | IEventMap[] | undefined | void;

export interface EventsMap {
  [actionType: string]: EventDefinition<any>;
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/public/analytics/types.ts